<template>
    <div class="containerBg">
      <div class="topView">
          <img class="topViewBg" src="../../assets/images/parkingTopBg.png"/>
          <div class="topViewdiv">
              <div class="topView_item">
                   <img class="topView_item_icon" src="../../assets/images/icon_parking_company.png" />
                   <span class="topView_item_span">{{defaultTenant.company}}</span>
              </div>
              <div class="topView_item1">
                  <img class="topView_item_icon" src="../../assets/images/icon_discount_p.png" />
                   <span class="topView_item_span">{{common.userTenantInfo.userName}}</span>
              </div>
          </div>
          <div class="topView_chakan" @click="toAdd()">
              <span class="topView_chakan_span">新增临停优惠</span>
              <img class="topView_chakan_icon" src="../../assets/images/icon_indicator_next.png" />
          </div>
      </div>
      <div class="listViewTB" v-if="dataList.length>0">
          <div class="listItem" v-for="(item,index) in dataList" :key="index" @click="applyDetail(item)">
               <div class="listItemDiv1">
                   <div class="listItemDiv1_Left">
                       <img class="listItemDiv1_Left_icon" src="../../assets/images/icon_contract.png"/>
                       <span class="listItemDiv1_Left_span">{{item.applyStartDay |date}} 至 {{item.applyEndDay |date}}</span>
                   </div>
                   <div class="listItemDiv1_Right">
                       <span v-if="item.applyStatus==1" class="listItemDiv1_Right_span">{{item.applyStatus |statusString}}</span>
                       <span v-if="item.applyStatus==3" class="listItemDiv1_Right_span1">{{item.applyStatus |statusString}}</span>
                   </div>
               </div>
               <div class="listItemDiv2">
                   <div class="listItemDiv2_LeftDiv">
                       <span class="listItemDiv2_LeftDiv_span1">车牌号</span>
                       <span class="listItemDiv2_LeftDiv_span2">{{item.plateNo}}</span>
                   </div>
                   <div class="listItemDiv2_RightDiv">
                        <span class="listItemDiv2_RightDiv_span1">申请时间</span>
                        <span class="listItemDiv2_RightDiv_span2">{{item.applyAt |date}}</span>
                   </div>
               </div>
               <div class="listItemDiv22" v-if="item.applyStatus==3">
                   <span class="listItemDiv22_span1">拒绝理由</span>
                   <span  class="listItemDiv22_span2">{{item.reason}}</span>
               </div>
               <div class="listItemDiv3">
                   <span class="listItemDiv3_span" @click="applyDetail(item)" >查看详情</span>
               </div>
               <!-- &&!item.startDay -->
               <img class="effectIcon" v-if="item.applyStatus==2 " src="../../assets/images/icon_take_effect.png"/>
               <img class="effectIcon" v-if="item.applyStatus==4" src="../../assets/images/icon_take_effectt.png"/>
          </div>
      </div>
      <div class="nodataDiv" v-if="dataList.length ==0 &&isLoad">
          <span class="nodataSpan">暂无申请记录～</span>
      </div>
    </div>
</template>
<script>
import util from "@/utils/util";
import CardNumber from './components/cardNumber';
import {mapState} from 'vuex';
import {approvalMixin} from '../../utils/approvalMixin';
import{loadParkHeaderById,spaceUpPcHttp} from "../../utils/api";
import storage from '../../utils/storage';
export default {
    mixins:[approvalMixin],
    components: {
        CardNumber
    },
     filters: {
       date: function (value) {
            if(!value){
                return '';
            }
            if(value){
                return value.split(" ")[0]
            }else{
                return ''
            }
            //return util.formatTime(new Date(value), 4)
       },
       statusString: function (value) {
           var str=''
           switch(value){
               case 1:{
                   str ="审核中";
                   break;
               }
               case 2:{
                   str ="审批通过";
                   break;
               }
               case 3:{
                   str ="审核失败";
                   break;
               }
           }
           return str;
       },
    },
    computed: {
        ...mapState({
            common: state => state.common
        }),

        defaultTenant() {
            let data = this.common.userTenantInfoList || [];
            let defaultD = {};
            data.forEach(item => {
                if (item.isDeafult == 1) {
                defaultD = item;
                }
            });
            return defaultD;
        }
    },

    data(){
        return {
            isLoad:false,
            parkHeaderId:'',
            dataList:'',
        }
    },
     created() {
         this.parkHeaderId =  this.$route.query.parkHeaderId;
         if(!this.common.userId){
            this.$router.push({
                path:'/login',
                query:{
                    Rurl:`/discountList?marketId=${this.$route.query.marketId}&cityId=${this.$route.query.cityId}&parkHeaderId=${this.$route.query.parkHeaderId}`
                }
            });
            return;
         }
         this.getMyDiscountParkLot();
     },
      mounted(){

    },
    methods:{

        toAdd(){
            this.$router.replace(`/parkingDiscount?&parkHeaderId=${this.parkHeaderId}`);
        },
         getMyDiscountParkLot(){
            let params =
                {
                    "subProjectId":this.common.marketInfo.id,
                    "parkHeaderId":this.parkHeaderId,
                    "phone":this.common.userInfo.account || this.common.userInfo.phone,
                    "url":"/parking/rstParkLot/loadDiscountParkLot"
                }
                loadParkHeaderById(params).then(res=>{
                    this.isLoad =true;
                    if(res.res && res.res.code === 10000 && res.body){

                        this.dataList =res.body.data;

                        // console.log('this.dataList ==== ' +  JSON.stringify(this.dataList))
                    }
                })
        },
         applyDetail(item){
            this.$router.push("/parkingApplyDetail?id="+item.parkHeaderId+"&applyId="+item.id+"&fromType="+'2')
         },
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.containerBg{
    background:#eee;
}
.topView{
    position: relative;
    height: 186px;
    width: 100%;
}
.cardBg{
     background:#eee;
     margin-top: 14px;
}
.topViewBg{
    position:absolute;
    left: 0px;
    top: 0px;
    height: 186px;
    width: 100%;
    z-index: 1;
}
.topViewdiv{
    position:absolute;
    left: 0px;
    top: 0px;
    height: 186px;
    width: 100%;
    z-index: 111;
    flex-direction: column;
}
.topView_item{
    flex-direction: row;
    margin-top: 40px;
     width: 100%;
     align-items: center;
     display: flex;
}
.topView_item1{
    flex-direction: row;
    margin-top: 18px;
     width: 100%;
     align-items: center;
     display: flex;
}
.topView_item_icon{
    margin-left: 30px;
    width: 36px;
    height: 36px;
    margin-right: 16px;
}
.topView_item_span{
    height:44px;
    width: 436px;
    font-size:32px;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:44px;
     white-space: nowrap;
     overflow: hidden;
    text-overflow: ellipsis;
}

.topView_chakan{
    right: 28px;
    top: 42px;
    position: absolute;
    flex-direction: row;
    z-index: 1111;
}
.topView_chakan_span{

    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
}
.topView_chakan_icon{
    margin-left: 4px;
    // margin-top: 4px;
    width: 32px;
    height: 32px;
}

.listViewTB{
    flex-direction: column;
    margin-top: 14px;
}
.listItem{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    position: relative;
}
.effectIcon{
    position: absolute;
    width: 120px;
    height: 120px;
    z-index: 101;
    right: 24px;
    top: 24px;
}
.listItemDiv1{
    width:750px;
    height:88px;
    background:rgba(255,255,255,1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.listItemDiv1_Left{
    flex-direction: row;
    align-items: center;
    margin-left: 28px;
}
.listItemDiv1_Left_icon{
    width: 44px;
    height: 44px;
}
.listItemDiv1_Left_span{
    height:40px;
    margin-left: 10px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.listItemDiv1_Right{
    flex-direction: row;
    align-items: center;
    margin-right: 28px;
}
.listItemDiv1_Right_span{
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:36px;
}
.listItemDiv1_Right_span1{
    height:36px;
    font-size:26px;
    font-weight:400;
    color:#FC3F56;
    line-height:36px;

}

.listItemDiv2{
    width:750px;
    height:100px;
    background:#FAFAFA;
    display: flex;
    flex-direction: row;
    align-items: center;
    //justify-content: space-between;
}
.listItemDiv22{
    width:750px;
    background:#FAFAFA;
    display: flex;
    flex-direction: row;
    padding-bottom: 28px;
}
.listItemDiv22_span1{
    margin-left: 28px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:36px;
}
.listItemDiv22_span2{
    margin-left: 20px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:36px;
}

.listItemDiv2_LeftDiv{
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.listItemDiv2_LeftDiv_span1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}
.listItemDiv2_LeftDiv_span2{
    font-size:28px;
    margin-left: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 2px;
    padding-bottom: 2px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
    background:rgba(0,135,255,1);
    border-radius:4px;
}
.listItemDiv2_RightDiv{
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.listItemDiv2_RightDiv_span1{
     margin-left: 20px;
     margin-left: 28px;
     height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}


.listItemDiv2_RightDiv_span2{
     margin-left: 12px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.listItemDiv3{
    width:750px;
    height:88px;
    background:rgba(255,255,255,1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}
.listItemDiv3_span{
    margin-right: 28px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 8px;
    padding-bottom: 6px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:36px;
    border-radius:4px;
    border:1px solid rgba(218,218,218,1);
}

.nodataDiv{
    margin-top: 100px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.nodataSpan{
    height:44px;
    font-size:32px;
    color:rgba(201,201,201,1);
    line-height:44px;
    margin-top:100px;

}

</style>
